import { ArtworkDBType } from '~/graphqls/types'
// 计算版权商品价格
type PriceObj = { price: any | null; name: string } | null
const getPrice = (priceList: PriceObj[] | null) => {
  // const priceNumbers = priceList?.map(item => item?.price || 0) || []
  const initial = {
    isSame: true,
    max: 0,
    min: 0,
    maxName: '',
    minName: '',
  }
  if (!priceList?.length) {
    return initial
  }
  const first = priceList[0]
  initial.min = first?.price || 0
  initial.minName = first?.name || ''
  priceList.reduce((init, cur) => {
    if (cur && init.max < cur.price) {
      init.max = cur.price
      init.maxName = cur.name
    }
    if (cur && init.min > cur.price) {
      init.min = cur.price
      init.minName = cur.name
    }
    return init
  }, initial)
  // 是否相同
  initial.isSame = initial.max === initial.min
  return initial
}
export const getProductPrice = (product: any) => {
  // 返回价格 对象
  const priceObj = {
    isSame: true,
    max: 0,
    min: 0,
    maxName: '',
    minName: '',
  }
  if (!product) {
    return priceObj
  }
  const { type, use, other } = product
  if (type === ArtworkDBType.AI_COPYRIGHT) {
    // ai 作品
    return getPrice([...(use || []), ...(other || [])])
  }
  return priceObj
}
